import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import LoginPage from "./components/LoginPage";
import DashboardLayout from "./components/Layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Rooms from "./pages/Rooms";
import Packages from "./pages/Packages";
import Staff from "./pages/Staff";
import Reports from "./pages/Reports";
import Calendar from "./pages/Calendar";
import AdminBooking from "./pages/AdminBooking";
import Bookings from "./pages/Bookings";
import Gallery from "./pages/Gallery";
import ExplorePage from "./pages/ExplorePage";
import Settings from "./pages/Settings";
import TicketPage from "./pages/TicketPage";
import HR from "./pages/HR";
import Inventory from "./pages/Inventory";
import AboutContent from "./pages/AboutContent";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// App Content Component
const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
      />
      <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="rooms" element={<Rooms />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="packages" element={<Packages />} />
        <Route path="staff" element={<Staff />} />
        <Route path="reports" element={<Reports />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="admin-booking" element={<AdminBooking />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="explore" element={<ExplorePage />} />
        <Route path="settings" element={<Settings />} />
        <Route path="tickets" element={<TicketPage />} />
        <Route path="hr" element={<HR />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="about-content" element={<AboutContent />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;